@if (activeLicenseDiv) {
  <div class="content-test">
    <div class="row-content-test">
      <h4>License Key API:
        @if (activeKey === 'licenseServer') {
          {{licenseServer ? licenseServer : ' N/A '}}
        }
        @if (activeKey !== 'licenseServer') {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKey || activeKey !== "licenseServer") {
            <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)="setActiveKey('licenseServer')" svgIcon='show' style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseServer" && activeKey) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseServer)'></mat-icon>
        }@else {
          @if (!activeKey || activeKey !== "licenseServer") {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)="setActiveKey('licenseServer')" svgIcon='show' style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseServer" && activeKey) {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseServer)'></mat-icon>
        }
        </div>
    </div>
    <!-- licenseWizard -->
    <div class="row-content-test">
      <h4>License Key Easy Checkout:
        @if (activeKey === 'licenseWizard') {
          {{licenseWizard ? licenseWizard : ' N/A '}}
        }
        @if (activeKey !== 'licenseWizard') {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKey || activeKey !== "licenseWizard") {
            <mat-icon i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='setActiveKey("licenseWizard")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseWizard" && activeKey) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)'  svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseWizard)'></mat-icon>
        }@else {
          @if (!activeKey || activeKey !== "licenseWizard") {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-ShowApi-Key' matTooltip="Visualizza API-KEY " matTooltipPosition="above" (click)='setActiveKey("licenseWizard")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseWizard" && activeKey) {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)'  svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseWizard)'></mat-icon>
        }
        </div>
    </div>
    <!-- Smart -->
    <div class="row-content-test">
      <h4>License Key Smart Checkout:
        @if (activeKey === 'licenseJS') {
          {{licenseJS ? licenseJS : ' N/A '}}
        }
        @if (activeKey !== 'licenseJS') {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKey || activeKey !== "licenseJS") {
            <mat-icon svgIcon='show' style="margin-right: 8px;" (click)='setActiveKey("licenseJS")'></mat-icon>
          }
          @if (activeKey === "licenseJS" && activeKey) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseJS)'></mat-icon>
        }@else{
          @if (!activeKey || activeKey !== "licenseJS") {
            <mat-icon class="iconDarkTheme" svgIcon='show' style="margin-right: 8px;" (click)='setActiveKey("licenseJS")'></mat-icon>
          }
          @if (activeKey === "licenseJS" && activeKey) {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseJS)'></mat-icon>
        }
      </div>
    </div>
    <!-- In-App -->
    <div class="row-content-test">
      <h4>License Key In-App Checkout(SDK iOS):
        @if (activeKey === 'licenseIos') {
          {{licenseIos ? licenseIos : ' N/A '}}
        }
        @if (activeKey !== 'licenseIos') {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKey || activeKey !== "licenseIos") {
            <mat-icon (click)='setActiveKey("licenseIos")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseIos" && activeKey) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseIos)'></mat-icon>
        }@else {
          @if (!activeKey || activeKey !== "licenseIos") {
            <mat-icon class="iconDarkTheme" (click)='setActiveKey("licenseIos")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseIos" && activeKey) {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseIos)'></mat-icon>        
        }
      </div>
    </div>
    <div class="row-content-test">
      <h4>License Key In-App Checkout(SDK Android):
        @if (activeKey === 'licenseAndroid') {
          {{licenseAndroid ? licenseAndroid : ' N/A '}}
        }
        @if (activeKey !== 'licenseAndroid') {
          ******* ******* ******* *******
        }
      </h4>
      <div>
        @if (theme !=='dark-theme') {
          @if (!activeKey || activeKey !== "licenseAndroid") {
            <mat-icon (click)='setActiveKey("licenseAndroid")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseAndroid" && activeKey) {
            <mat-icon i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseAndroid)'></mat-icon>
        }@else {
          @if (!activeKey || activeKey !== "licenseAndroid") {
            <mat-icon class="iconDarkTheme" (click)='setActiveKey("licenseAndroid")' svgIcon='show'
            style="margin-right: 8px;"></mat-icon>
          }
          @if (activeKey === "licenseAndroid" && activeKey) {
            <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-HideApi-Key' matTooltip="Nascondi API-KEY" matTooltipPosition="above" (click)='setActiveKey(null)' svgIcon='hide' style="margin-right: 8px;"></mat-icon>
          }
          <mat-icon class="iconDarkTheme" i18n-matTooltip='@@matTooltip-copyLicense' svgIcon='copy' matTooltip="Copia licenza" matTooltipPosition="above" (click)='copyLicense(licenseAndroid)'></mat-icon>
        }
      </div>
    </div>
  </div>
}
